import React from "react";
import {
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Spinner,
} from "reactstrap";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import {
  formInputChange,
  formInputChangeMultiple,
} from "../Actions/formAction";
import {
  patientFormDetails,
  patientFormDetailsSuccess,
  patientFormDetailsFailure,
} from "../Actions/formAction";
import { connect } from "react-redux";
import axios from "axios";
import { serverUrls } from "../Utils/Urls";

const inputsStyle = {
  display: "inline",
  marginRight: 0,
  maxHeight: 35,
  boxShadow: "none",
  fontSize: 14,
};

const labelStyle = {
  fontSize: 14,
};

class CreateFormInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.datepickerChange = this.datepickerChange.bind(this);
    this.submit = this.submit.bind(this);
    this.onChangeMultiple = this.onChangeMultiple.bind(this);
    this.getInput = this.getInput.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.state = {
      shouldSpin: {},
    };
  }

  onFileChange = (e) => {
    var name = e.target.name;
    let formData = new FormData();
    formData.append("file", e.target.files[0], e.target.files[0].filename);
    this.setState({
      shouldSpin: {
        ...this.state.shouldSpin,
        [name]: true,
      },
    });
    axios
      .post(serverUrls.upload, formData)
      .then((res) => {

        this.props.formInputChange({ name: name, value: res.data.url });
        // console.log("other one called"+ JSON.stringify(this.props))
        this.setState({
          shouldSpin: {
            ...this.state.shouldSpin,
            [name]: false,
          },
        });
      })
      .catch((err) => {
        this.setState({
          shouldSpin: {
            ...this.state.shouldSpin,
            [name]: false,
          },
        });
      });
  };

  onChangeMultiple = (e, num) => {
    this.props.formInputChange({
      name: e.target.name,
      value: e.target.value,
      typeNumber: num,
    });
  };

  onChange = (e) => {
    this.props.formInputChange({ name: e.target.name, value: e.target.value });
  };

  datepickerChange = (payload) => {
    this.props.formInputChange(payload);
  };

  selectChange = (payload) => {
    this.props.formInputChange(payload);
  };

  createFormGroupUpload = (key, values) => {
    const handleFileChange = (event) => {
      const file = event.target.files[0];
      const allowedExtensions = ["pdf"];
      const fileExtension = file
        ? file.name.split(".").pop().toLowerCase()
        : null;

      if (!allowedExtensions.includes(fileExtension)) {
        alert("Only PDF files are allowed.");
        event.target.value = "";
      } else {
        this.onFileChange(event);
      }
    };

    return (
      <FormGroup key={key} row>
        <Label style={labelStyle} for={key} sm={this.props.labelSize}>
          {values.label}
        </Label>
        
        <Col sm={this.props.size}>
          <input
            type="file"
            name={key}
            accept=".pdf"
            id={key}
            onChange={handleFileChange}
          />
          {/* <text> {JSON.stringify(this.props[key]) + "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"}</text> */}
          {this.state.shouldSpin[key] ? <Spinner size="sm" /> : null}
          {this.props[key] && this.props[key].length > 0 ? (
            <a
              className="btn btn-primary btn-sm"
              target="_blank"
              rel="noopener noreferrer"
              href={this.props[key]}
            >
              view
            </a>
          ) : null}
        </Col>
      </FormGroup>
    );
  };

  getInput = (i, key, type) => {
    return (
      <Input
        style={inputsStyle}
        value={this.props.formValues[i][key]}
        onChange={(e) => {
          this.onChangeMultiple(e, i);
        }}
        type={type}
        name={key}
        id={key}
      />
    );
  };

  createFormGroupInput = (key, values) => {
    if (this.props.label) {
      return (
        <FormGroup key={key} row>
          <Label style={labelStyle} for={key} sm={this.props.labelSize}>
            {values.label}
          </Label>
          <Col sm={10}>
            <Input
              style={inputsStyle}
              value={this.props[key]}
              onChange={this.onChange}
              type={values.type}
              name={key}
              id={key}
              placeholder={values.placeholder}
            />
          </Col>
        </FormGroup>
      );
    }
    if (this.props.count > 0) {
      var inputsList = [];
      for (let i = 0; i < this.props.count; i++) {
        inputsList.push(
          <Col sm={this.props.size} key={key + i}>
            {this.getInput(i, key, values.type)}
          </Col>
        );
      }
      return (
        <FormGroup key={key} row>
          <Label style={labelStyle} sm={this.props.labelSize} for={key}>
            {values.label}
          </Label>
          <Col sm={10}>
            <Row>{inputsList}</Row>
          </Col>
        </FormGroup>
      );
    }
    return (
      <FormGroup key={key} row>
        <Col sm={this.props.size}>
          <Input
            style={inputsStyle}
            value={this.props[key]}
            onChange={this.onChange}
            type={values.type}
            name={key}
            id={key}
          />
        </Col>
      </FormGroup>
    );
  };

  createFormGroupSelect = (key, values) => {
    var options = values.values;
    var opositeOptions = {};
    var optionsHtml = [];
    Object.keys(options).forEach((element) => {
      opositeOptions[options[element]] = element;
      optionsHtml.push(<option key={element}>{element}</option>);
    });

    if (this.props.label) {
      return (
        <FormGroup key={key} row>
          <Label style={labelStyle} sm={this.props.labelSize} for={key}>
            {values.label}
          </Label>
          <Col sm={10}>
            <Input
              style={inputsStyle}
              value={opositeOptions[this.props[key]]}
              onChange={(e) => {
                this.selectChange({
                  name: e.target.name,
                  value: options[e.target.value],
                });
              }}
              type={values.type}
              name={key}
              id={key}
            >
              {optionsHtml}
            </Input>
          </Col>
        </FormGroup>
      );
    }
    if (this.props.count > 0) {
      var inputsList = [];
      for (let i = 0; i < this.props.count; i++) {
        inputsList.push(
          <Col sm={this.props.size} key={key + i}>
            <Input
              style={inputsStyle}
              value={opositeOptions[this.props.formValues[i][key]]}
              onChange={(e) => {
                this.selectChange({
                  name: e.target.name,
                  value: options[e.target.value],
                  typeNumber: i,
                });
              }}
              type={values.type}
              name={key}
              id={key}
            >
              {optionsHtml}
            </Input>
          </Col>
        );
      }
      return (
        <FormGroup key={key} row>
          <Label style={labelStyle} sm={this.props.labelSize} for={key}>
            {values.label}
          </Label>
          <Col sm={10}>
            <Row>{inputsList}</Row>
          </Col>
        </FormGroup>
      );
    }
    return (
      <FormGroup key={key} row>
        <Col sm={this.props.size}>
          <Input
            style={inputsStyle}
            value={opositeOptions[this.props[key]]}
            onChange={(e) => {
              this.selectChange({
                name: e.target.name,
                value: options[e.target.value],
              });
            }}
            type={values.type}
            name={key}
            id={key}
          >
            {optionsHtml}
          </Input>
        </Col>
      </FormGroup>
    );
  };

  createFormGroupDatePicker = (key, values) => {
    return (
      <FormGroup key={key} row>
        <Label style={labelStyle} for={key} sm={this.props.labelSize}>
          {values.label}
        </Label>
        <Col sm={this.props.size}>
          <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={this.props[key]}
            onChange={(date) => {
              this.datepickerChange({
                name: key,
                value: date,
              });
            }}
            style={{ width: "100%" }}
            placeholderText={values.placeholder}
            customInput={
              <Input
                style={inputsStyle}
                name={key}
                id={key}
                placeholder={values.placeholder}
              />
            }
          />
        </Col>
      </FormGroup>
    );
  };

  createForm = () => {
    var htmlList = [];
    for (var key of Object.keys(this.props.inputs)) {
      var type = this.props.inputs[key].type;
      switch (type) {
        case "datepicker":
          htmlList.push(
            this.createFormGroupDatePicker(key, this.props.inputs[key])
          );
          break;
        case "text":
          htmlList.push(this.createFormGroupInput(key, this.props.inputs[key]));
          break;
        case "number":
          htmlList.push(this.createFormGroupInput(key, this.props.inputs[key]));
          break;
        case "email":
          htmlList.push(this.createFormGroupInput(key, this.props.inputs[key]));
          break;
        case "select":
          htmlList.push(
            this.createFormGroupSelect(key, this.props.inputs[key])
          );
          break;
        case "upload":
          htmlList.push(
            this.createFormGroupUpload(key, this.props.inputs[key])
          );
          break;
        default:
          htmlList.push(this.createFormGroupInput(key, this.props.inputs[key]));
          break;
      }
    }
    return htmlList;
  };

  submit = (e) => {
    e.preventDefault();
    const { formName, remarks, treatment } = this.props;
    if (formName === "getDisorderAndTreatment") {
      const combinedTreatment = `${treatment}🡸Disorder||Treatment🡺${remarks}`;
      const payload = {
        ...this.props,
        formInputChange: "",
        submit: "",
        inputs: {},
        treatment: combinedTreatment,
      };
      this.props.submit(
        payload,
        this.props.url,
        this.props.afterCall ? this.props.afterCall : (id) => {},
        this.props.isPost
      );
    } else {
      const payload = {
        ...this.props,
        formInputChange: "",
        submit: "",
        inputs: {},
      };
      this.props.submit(
        payload,
        this.props.url,
        this.props.afterCall ? this.props.afterCall : (id) => {},
        this.props.isPost
      );
    }
  };

  render() {
    return (
      <Form
        onKeyPress={(e) => e.key === "Enter" && this.submit(e)}
        style={{ textAlign: "left" }}
      >
        {this.createForm()}
        <br />
        <Button outline size="sm" onClick={this.submit}>
          {this.props.buttonName}
        </Button>
      </Form>
    );
  }
}

CreateFormInput.defaultProps = {
  isPost: true,
  label: true,
  size: 10,
  labelSize: 2,
  count: 0,
};

CreateFormInput.propTypes = {
  inputs: PropTypes.object.isRequired,
  formName: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isPost: PropTypes.bool,
  label: PropTypes.bool,
  size: PropTypes.number,
  labelSize: PropTypes.number,
  count: PropTypes.number,
};

const mapStateToProps = (state, props) => {
  return {
    ...state[props.formName],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formInputChange: (payload) => {
      if (payload.typeNumber !== undefined) {
        dispatch(formInputChangeMultiple(payload));
      } else {
        dispatch(formInputChange(payload));
      }
    },
    submit: (payload, url, afterCall = () => {}, isPost = true) => {
      if (isPost) {
        dispatch(patientFormDetails({ loading: true }));
        axios
          .post(url, payload)
          .then((res) => {
            dispatch(
              patientFormDetailsSuccess({
                loading: false,
                success: res.data.success,
                data: res.data.data,
              })
            );
            if (res.data.data && res.data.data.id) afterCall(res.data.data.id);
          })
          .catch((err) => {
            dispatch(
              patientFormDetailsFailure({
                loading: false,
                errors: err.response.data,
              })
            );
          });
      } else {
        dispatch(patientFormDetails({ loading: true }));
        axios
          .put(url, payload)
          .then((res) => {
            dispatch(
              patientFormDetailsSuccess({
                loading: false,
                success: res.data.success,
                data: res.data.data,
              })
            );
            if (res.data.data && res.data.data.id) afterCall(res.data.data.id);
          })
          .catch((err) => {
            dispatch(
              patientFormDetailsFailure({
                loading: false,
                errors: err.response.data,
              })
            );
          });
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateFormInput);
